export default {
  LOGO: 'logo',
  FAVICON: 'favicon',
  PLACEHOLDER: 'imagePlaceholder'
}